import React from "react";
import "./EraPage.css"; // Make sure the styles include .worldwars-banner, etc.

function WorldWars() {
  return (
    <div className="era-page">
      {/* Banner */}
      <div className="era-banner worldwars-banner">
        <h1>🌍 World Wars Era: A Time of Great Change</h1>
        <p className="era-subtitle">Grade 7 - World Wars Era</p>
      </div>

      {/* Overview */}
      <section className="worldwars-overview">
        <h2>🪖 What Were the World Wars?</h2>
        <p>
          The 1900s were marked by two major wars—World War I and World War II—that affected almost every country.
          These wars changed borders, governments, and the way people lived forever.
        </p>
      </section>

      {/* Key Figures & Events */}
      <section className="worldwars-key">
        <h2>🔎 Key Figures & Moments</h2>
        <ul>
          <li>🌐 <strong>World War I (1914–1918):</strong> Known as the “Great War.”</li>
          <li>🕊️ <strong>Armistice Day:</strong> The end of WWI on November 11, 1918.</li>
          <li>⚡ <strong>World War II (1939–1945):</strong> Sparked by the rise of dictators.</li>
          <li>🇨🇦 <strong>Canada’s Role:</strong> Canadian soldiers fought bravely in both wars.</li>
          <li>🚀 <strong>New Tech:</strong> Planes, tanks, and even early computers were used.</li>
        </ul>
      </section>

      {/* Story Section */}
      <section className="worldwars-story">
        <h2>📖 Story: “Letters from the Trenches”</h2>
        <p>
          “Dear Mama,” wrote Private Samuel, “The mud is deep, and the nights are cold, but I think of home often.
          We help each other laugh through the noise and fear. I miss your bread and the dog’s bark.”
          His letters gave hope during one of history’s darkest times.
        </p>
      </section>

      {/* Video */}
      <section className="worldwars-media">
        <h2>🎥 Learn with Video</h2>
        <img
  className="worldwars-illustration"
  src="/images/worldwars-era-scene.png"
  alt="Canadian soldier in WWI writing a letter in a trench, WWII nurse and plane, tank, and peaceful symbols"
  style={{ width: "100%", maxWidth: 500, borderRadius: "1.5rem", margin: "0 auto", boxShadow: "0 4px 24px rgba(0,0,0,0.12)" }}
/>
      </section>

      {/* Quiz */}
      <section className="worldwars-quiz">
        <h2>🧠 Quiz Yourself!</h2>
        <ol>
          <li>What year did World War I begin?</li>
          <li>Who fought in the trenches?</li>
          <li>What are some new inventions used in WWII?</li>
        </ol>
        <p><em>(Review the answers with a classmate!)</em></p>
      </section>

      {/* Timeline */}
      <section className="worldwars-timeline">
        <h2>📅 Timeline of the World Wars</h2>
        <ul>
          <li>1914 – World War I begins</li>
          <li>1918 – WWI ends with the Treaty of Versailles</li>
          <li>1939 – World War II begins</li>
          <li>1945 – WWII ends after the defeat of Nazi Germany & Japan</li>
        </ul>
      </section>
    </div>
  );
}

export default WorldWars;
